module.exports = __webpack_public_path__ + "media/images/method-traditional_transfer-b992a9cf8e35ebc41e6f827a57f717e3.png";